import { memo, useState } from "react";

import type { IChipProps } from "./types";
import styles from "./styles.module.scss";
import { getColor } from "./getColor";

export const Chip = memo(function Chip(props: IChipProps) {
  const { value, name } = props;

  const [hidden, setHidden] = useState(true);

  return (
    <div className={styles.wrapper}>
      <div className={styles.chipContainer}>
        {Array.isArray(name) ? (
          name.map((chipValue, index) => {
            return (
              <div
                key={chipValue}
                className={`${styles.chip} ${
                  index > 0 && hidden && styles.hidden
                }`}
                style={{
                  color: getColor(chipValue?.toString()),
                  background: `${getColor(chipValue?.toString())}1A`,
                }}
              >
                {value[index]}
              </div>
            );
          })
        ) : (
          <div
            className={styles.chip}
            style={{
              color: getColor(name?.toString()),
              background: `${getColor(name?.toString())}1A`,
            }}
          >
            {value}
          </div>
        )}
      </div>
      {Array.isArray(name) &&
        name.length > 1 &&
        (hidden ? (
          <div
            className={styles.secondaryChip}
            onClick={() => setHidden(false)}
          >
            {name.length - 1}
            {"+\r"}
          </div>
        ) : (
          <div className={styles.arrowContainer}>
            <span
              onClick={() => setHidden(true)}
              className={"icon-linear_arrow-up"}
            />
          </div>
        ))}
    </div>
  );
});
